<template>
  <div>
    <b-tabs v-model="activeTab" justified nav-class="nav-tabs-main" content-class="p-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">{{ $t("asset-group.organization") }}</span>
        </template>
        <div class="card rounded p-4" v-if="activeTab == 0">
          <h1 class="title mt-1">{{ $t("asset-group.organization") }}</h1>
          <AssetGroupCategoryBoxes />
          <AssetGroupBoxes />
        </div>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">
            <span>{{ $t("asset-group.list-view") }} </span>
          </span>
        </template>
        <organizationAssetGroupCategoryAssetGroupInventoryListView v-if="activeTab == 1" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">
            <span>{{ $t("asset-group.degree-of-criticality") }} </span>
          </span>
        </template>
        <OrganizationAssetGroupCategoryAssetGroupCriticalityView v-if="activeTab == 2" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import OrganizationAssetGroupCategoryAssetGroupCriticalityView from "../asset-group-inventory/organization-asset-group-category-asset-group-criticality-view.vue";
import OrganizationAssetGroupCategoryAssetGroupInventoryListView from "../asset-group-inventory/organization-asset-group-category-asset-group-inventory-list-view.vue";
import AssetGroupBoxes from "./component/asset-group-boxes.vue";
import AssetGroupCategoryBoxes from "./component/asset-group-category-boxes.vue";

export default {
  components: {
    AssetGroupCategoryBoxes,
    AssetGroupBoxes,
    OrganizationAssetGroupCategoryAssetGroupInventoryListView,
    OrganizationAssetGroupCategoryAssetGroupCriticalityView,
  },

  beforeDestroy() {
    //this.$store.commit("assetGroupBoxes/clear");
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    redirectToAssetGroupListView() {
      this.$router.push("/organization/asset-group-inventory/asset-groups");
    },
    redirectToInventory() {
      this.$router.push("/organization/asset-groups/inventory");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
